import apiClient from './axios';

const getDeviceId = () => {
  let deviceId = localStorage.getItem('device_id');

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('device_id', deviceId);
  }

  return deviceId;
};

const authApi = {
  login: async ({ identifier, password, fcm_token, timezone, platform, device_name, device_id }) => {
    try {
      const response = await apiClient.post('/login', {
        identifier,
        password,
        fcm_token,
        timezone: timezone || 'Asia/Kolkata',
        platform: platform,
        device_name: device_name,
        device_id: device_id || getDeviceId(),
      });

      // console.log("data,", response.data);
      return response.data; // Expected: { access, refresh, is_first_login, employee: {...} }
    } catch (err) {
      throw err;
    }
  },

  //  logout: async ({ device_id }) => {
  //   try {
  //     const response = await apiClient.post(
  //       '/logout',
  //       {
  //         device_id,
  //       }
  //     );

  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  logout: async ({ device_id }) => {
    const response = await apiClient.post('/logout', {
      device_id: device_id
    });

    return response.data;
  },

  // requestPasswordReset: async (identifier) => {
  //   const response = await apiClient.post('/password-reset/request/', { identifier });
  //   return response.data;
  // },

  requestPasswordReset: async (identifier) => {
    const payload = {
      identifier: identifier,
      platform: 'web' // Required by your spec
    };
    const response = await apiClient.post('/password/forgot', payload);
    return response.data;
  },

  // resetPassword: async (token, newPassword, confirmPassword) => {
  //   const response = await apiClient.post(
  //     '/password_reset/',
  //     {
  //       new_password: newPassword,
  //       confirm_password: confirmPassword,
  //     },
  //     {
  //       headers: { Authorization: `Bearer ${token}` },
  //     }
  //   );
  //   return response.data;
  // },

  resetPassword: async (token, newPassword, confirmPassword) => {
    const payload = {
      token: token,
      password: newPassword,
      password_confirmation: confirmPassword
    };
    // Note: The spec implies the token is in the BODY, not the Header
    const response = await apiClient.post('/password/reset', payload);
    return response.data;
  },
  
};

export default authApi;